<template>
  <div style="height: 100%">

    <b-dropdown size="sm" split text="Inverter" right variant="dark" class="m-2" v-if="is_editable">
      <!-- <b-dropdown-item :href="`/mainDashboardSiteDetail/`" target="_blank">
        <div class="icon-map-marker-cs"></div>
        <span>Dashboard</span>
      </b-dropdown-item>
      -->
      <b-dropdown-item @click="modal_show('modal-pv-test-generate-inverter-entry')">
        <div class="icon-pencil-cs"></div>
        <span>Create n entry</span>
      </b-dropdown-item>
      <b-dropdown-item @click="modal_show('modal-pv-test-update-inverter-entry', 'update')">
        <div class="icon-pencil-cs"></div>
        <span>Update Selected entry</span>
      </b-dropdown-item>
    </b-dropdown>
    <b-dropdown size="sm" split text="String" right variant="dark" class="m-2" v-if="is_editable">
      <b-dropdown-item @click="modal_show('modal-pv-test-generate-string-entry', 'add_string')">
        <div class="icon-pencil-cs"></div>
        <span>Create n entry</span>
      </b-dropdown-item>
      <b-dropdown-item @click="modal_show('modal-pv-test-update-string-entry', 'update')">
        <div class="icon-pencil-cs"></div>
        <span>Update Selected entry</span>
      </b-dropdown-item>
      <b-dropdown-item @click="modal_show('modal-pv-test-rename-string-entry', 'update')">
        <div class="icon-pencil-cs"></div>
        <span>Batch Rename</span>
      </b-dropdown-item>
    </b-dropdown>
    

    <!--     
    <button type="button" @click="batch_add_ac_test_entry()" style="margin: 10px">Generate n entry</button>
    <button type="button" @click="batch_update_ac_test_entry()" style="margin: 10px">Update Selected entry</button> 
    -->


    <!-- :gridOptions="gridOptions" @selection-changed="onSelectionChanged" :detailRowAutoHeight="true" :detailRowHeight=100 
      :detailCellRendererParams="oGrid.detailCellRendererParams_pv_string"  
      :columnDefs="oGrid.columnDefs_pv_inverter" 
      :rowData="rowData" 
     -->
    <ag-grid-vue style="width: 100%; height: 600px;" class="flex-grow-1 flex-shrink-1 ag-theme-alpine" rowSelection="multiple"
      :suppressRowClickSelection="true" 
      :gridOptions="oGrid.gridOptions_pv_inverter"
      :defaultColDef="defaultColDef" 
      :masterDetail="true" 
      @grid-ready="onGridReady">
    </ag-grid-vue>

    <!-- Modal loading / in progress -->
    <!-- <b-modal ref="modal-loading-in-progress" size="lg" centered hide-footer hide-header title="" :no-close-on-backdrop="true"> -->
    <b-modal ref="modal-loading-in-progress" size="lg" centered hide-footer hide-header title="">
      <div class="d-block">
        <!-- date | time | project name | site name -->
        <b-row class="mb-3">
          <b-col>
            <div class="text-center text-muted mb-4">
              <h1 class="text-white"><b>Loading in progress</b></h1>
            </div>
            <div class="text-center">
              <div style="color: #ffffff;">
                <!-- <span class="fa fa-spinner fa-spin fa-3x"></span> -->
                <span class="icon-spinner-cs"></span>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>


    <!-- modal generate n pv test - inverter and string -->
    <b-modal ref="modal-pv-test-generate-inverter-entry" size="lg" centered hide-footer hide-header title="">
      <div class="d-block">
        <b-row class="modal-row-header">
          <b-col>
            <div class="text-white h3"># of PV Electrical Test entry</div>
          </b-col>
        </b-row>
        <!-- desc observation -->
        <b-row>
          <!-- inverter -->
          <b-col class="mb-2" sm="12" md="12" lg="6" xl="6">
            <b-row>
              <b-col class="mb-2" sm="12" md="12" lg="12" xl="12">
                <label class="mb-1 text-white" for="">No of inverter entries to be created</label>
                <b-form-input type="number" step="1" min="1" placeholder="No of inverter entries to be created." v-model="oModel.pvTest_new_inverter.create"></b-form-input>
              </b-col>        
              <b-col class="mb-2" sm="12" md="12" lg="12" xl="12">
                <label class="mb-1 text-white" for="">Prefix for Inverter entry</label>
                <b-form-input placeholder="Prefix for Inverter entry" v-model="oModel.pvTest_new_inverter.prefix"></b-form-input>
              </b-col>
              <b-col class="mb-2" sm="12" md="12" lg="12" xl="12">
                <label class="mb-1 text-white" for="">Inverter number start from</label>
                <b-form-input type="number" step="1" min="1" placeholder="Inverter number start from." v-model="oModel.pvTest_new_inverter.start"></b-form-input>
              </b-col>  
            </b-row>
          </b-col>
          <!-- string -->
          <b-col class="mb-2" sm="12" md="12" lg="6" xl="6">
            <b-row>
              <b-col class="mb-2" sm="12" md="12" lg="12" xl="12">
                <label class="mb-1 text-white" for="">No of string per-inverter </label>
                <b-form-input type="number" step="1" min="1" placeholder="No of string entries to be created per-inverter." v-model="oModel.pvTest_new_string.create"></b-form-input>
              </b-col>
              <b-col class="mb-2" sm="12" md="12" lg="12" xl="12">
                <label class="mb-1 text-white" for="">Prefix for String entry</label>
                <b-form-input placeholder="Prefix for String entry" v-model="oModel.pvTest_new_string.prefix"></b-form-input>
              </b-col>
              <b-col class="mb-2" sm="12" md="12" lg="12" xl="12">
                <label class="mb-1 text-white" for="">Optional: Postfix for String entry</label>
                <b-form-input placeholder="Optional: Postfix for String entry" v-model="oModel.pvTest_new_string.postfix"></b-form-input>
              </b-col>
            </b-row>
          </b-col>
          <!-- information -->
          <b-col class="mb-2" sm="12" md="12" lg="12" xl="12">
            <span style="color: white; font-family: Open Sans, sans-serif; font-size: 0.9rem; font-weight: 400;">
              Information: 
              <br>With <i><u>No of inverter to be created</u></i> is <b>5</b>, then 
              <br><i><u>Prefix for inverter entry</u></i> is <b>INV </b>, and 
              <br><i><u>Inverter number start from</u></i> is <b>6</b>, 
              <br><br>it will create "INV 6, INV 7, INV 8, INV 9 and INV 10"
            </span>
          </b-col>
        </b-row>
        <b-row style="padding-top: 20px;" v-if="is_editable">
          <b-col class="text-right">
            <base-button @click="modal_close('modal-pv-test-generate-inverter-entry')" type="danger" outline>Cancel</base-button>
            <base-button @click="batch_process_add_pv_test_inverter_entry()" type="primary">Save</base-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <!-- modal update pv test - inverter & string -->
    <b-modal ref="modal-pv-test-update-inverter-entry" size="xl" centered hide-footer hide-header title="">
      <div class="d-block">
        <b-row class="modal-row-header">
          <b-col>
            <div class="text-white h3">Batch Update Inverter entry</div>
          </b-col>
        </b-row>
        <!-- inverter information -->
        <b-row>
          <b-col class="mb-2" md="12" lg="4" xl="4">
            <label for="" class="text-white">Inverter No</label>
            <b-form-input placeholder="" v-model="oModel.pvTest_update_inverter.inverter_no"></b-form-input>
          </b-col>
          <b-col class="mb-2" md="12" lg="4" xl="4">
            <label for="" class="text-white">Capacity (kWp)</label>
            <b-form-input type="number" placeholder="" v-model="oModel.pvTest_update_inverter.capacity"></b-form-input>
          </b-col>
          <b-col class="mb-2" md="12" lg="4" xl="4">
            <label for="" class="text-white">No of Strings</label>
            <b-form-input type="number" placeholder="" v-model="oModel.pvTest_update_inverter.no_of_strings"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mb-2" md="12" lg="4" xl="4">
            <label for="" class="text-white">Model No</label>
            <b-form-input placeholder="" v-model="oModel.pvTest_update_inverter.model_no"></b-form-input>
          </b-col>
          <b-col class="mb-2" md="12" lg="4" xl="4">
            <label for="" class="text-white">DC/AC ratio</label>
            <b-form-input type="number" placeholder="" v-model="oModel.pvTest_update_inverter.dc_ac_ratio"></b-form-input>
          </b-col>
          <b-col class="mb-2" md="12" lg="4" xl="4">
            <label for="" class="text-white">Inverter Serial No</label>
            <b-form-input placeholder="" v-model="oModel.pvTest_update_inverter.inverter_serial_no"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mb-2" md="12" lg="6" xl="6">
            <label for="" class="text-white">DC Cable Type & Size</label>
            <b-form-input placeholder="" v-model="oModel.pvTest_update_inverter.dc_cable_type_and_size"></b-form-input>
          </b-col>
          <b-col class="mb-2" md="12" lg="6" xl="6">
            <label for="" class="text-white">Earth Cable Type & Size</label>
            <b-form-input placeholder="" v-model="oModel.pvTest_update_inverter.earth_cable_type_and_size"></b-form-input>
          </b-col>
        </b-row>
        <!-- String Over Current Over Protection Device -->
        <hr class="hr" />
        <b-row class="modal-row-category">
          <b-col>
            <div class="text-white h3">String Over Current Over Protection Device</div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mb-2" md="12" lg="3" xl="3">
            <label for="" class="text-white">Type</label>
            <b-form-input placeholder="" v-model="oModel.pvTest_update_inverter.socpd_type"></b-form-input>
          </b-col>
          <b-col class="mb-2" md="12" lg="3" xl="3">
            <label for="" class="text-white">Rating (A)</label>
            <b-form-input type="number" placeholder="" v-model="oModel.pvTest_update_inverter.socpd_rating"></b-form-input>
          </b-col>
          <b-col class="mb-2" md="12" lg="3" xl="3">
            <label for="" class="text-white">DC Rating (V)</label>
            <b-form-input type="number" placeholder="" v-model="oModel.pvTest_update_inverter.socpd_dc_rating"></b-form-input>
          </b-col>
          <b-col class="mb-2" md="12" lg="3" xl="3">
            <label for="" class="text-white">Capacity (KA)</label>
            <b-form-input type="number" placeholder="" v-model="oModel.pvTest_update_inverter.socpd_capacity"></b-form-input>
          </b-col>
        </b-row>

        <!-- buttons -->
        <b-row style="padding-top: 20px;" v-if="is_editable">
          <b-col class="text-right">
            <base-button @click="modal_close('modal-pv-test-update-inverter-entry')" type="danger" outline>Cancel</base-button>
            <base-button @click="batch_process_update_pv_test_inverter_entry()" type="primary">Save</base-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <!-- modal generate n string entry -->
    <b-modal ref="modal-pv-test-generate-string-entry" size="lg" centered hide-footer hide-header title="">
      <div class="d-block">
        <b-row class="modal-row-header">
          <b-col>
            <div class="text-white h3"># Add new string entry on selected inverter</div>
          </b-col>
        </b-row>
        <!-- desc observation -->
        <b-row>
          <b-col class="mb-2" sm="12" md="12" lg="6" xl="6">
            <label class="mb-1 text-white" for="">No of string to be create </label>
            <b-form-input type="number" step="1" min="1" placeholder="No of string to be create." v-model="oModel.pvTest_new_string.create"></b-form-input>
          </b-col>
          <b-col class="mb-2" sm="12" md="12" lg="6" xl="6">
            <label class="mb-1 text-white" for="">String number start from</label>
            <b-form-input type="number" step="1" min="1" placeholder="String number start from." v-model="oModel.pvTest_new_string.start"></b-form-input>
          </b-col>  
          <b-col class="mb-2" sm="12" md="12" lg="6" xl="6">
            <label class="mb-1 text-white" for="">Prefix for String entry</label>
            <b-form-input placeholder="Prefix for String entry" v-model="oModel.pvTest_new_string.prefix"></b-form-input>
          </b-col>
          <b-col class="mb-2" sm="12" md="12" lg="6" xl="6">
            <label class="mb-1 text-white" for="">Optional: Postfix for String entry</label>
            <b-form-input placeholder="Optional: Postfix for String entry" v-model="oModel.pvTest_new_string.postfix"></b-form-input>
          </b-col>

        </b-row>
        <b-row style="padding-top: 20px;" v-if="is_editable">
          <b-col class="text-right">
            <base-button @click="modal_close('modal-pv-test-generate-string-entry')" type="danger" outline>Cancel</base-button>
            <base-button @click="batch_process_add_pv_test_string_entry()" type="primary">Save</base-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <!-- modal update pv test - string only -->
    <b-modal ref="modal-pv-test-update-string-entry" size="xl" centered hide-footer hide-header title="">
      <div class="d-block">
        <b-row class="modal-row-header">
          <b-col>
            <div class="text-white h3">Update String entry</div>
          </b-col>
        </b-row>
        <!-- inverter information -->
        <b-row>
          <b-col class="mb-2" sm="12" md="6" lg="4" xl="3">
            <label for="" class="text-white">String No</label>
            <b-form-input v-model="oModel.pvTest_update_string.string_no"></b-form-input>
          </b-col>
          <b-col class="mb-2" sm="12" md="6" lg="4" xl="3">
            <label for="" class="text-white">No of PV Module Per-String</label>
            <b-form-input type="number" v-model="oModel.pvTest_update_string.pv_modules_per_string"></b-form-input>
          </b-col>
          <b-col class="mb-2" sm="12" md="6" lg="4" xl="3">
            <label for="" class="text-white">Positive - Earth</label>
            <b-form-input v-model="oModel.pvTest_update_string.positive_earth"></b-form-input>
          </b-col>
          <b-col class="mb-2" sm="12" md="6" lg="4" xl="3">
            <label for="" class="text-white">Negative - Earth</label>
            <b-form-input v-model="oModel.pvTest_update_string.negative_earth"></b-form-input>
          </b-col>
          <b-col class="mb-2 mt-4" md="12" lg="12" xl="12">
            <label for="" class="text-white">String Polarity Check</label>&nbsp;&nbsp;&nbsp;
            <toggle-button class="mr-2" v-model="oModel.pvTest_update_string.string_polarity_check" :labels="oField.toggle_pass" :color="oField.toggle_color" :width="80" sync/>
          </b-col>
        </b-row>
        <!-- String Over Current Over Protection Device -->
        <hr class="hr" />
        <b-row class="modal-row-category">
          <b-col>
            <div class="text-white h3">String Test</div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mb-2" sm="12" md="6" lg="4" xl="3">
            <label for="" class="text-white">ISC (A)</label>
            <b-form-input type="number" v-model="oModel.pvTest_update_string.pv_string_test.isc_a"></b-form-input>
          </b-col>
          <b-col class="mb-2" sm="12" md="6" lg="4" xl="3">
            <label for="" class="text-white">ISC @ STC (A)</label>
            <b-form-input type="number" v-model="oModel.pvTest_update_string.pv_string_test.isc_stc_a"></b-form-input>
          </b-col>
          <b-col class="mb-2" sm="12" md="6" lg="4" xl="3">
            <label for="" class="text-white">VOC (V)</label>
            <b-form-input type="number" v-model="oModel.pvTest_update_string.pv_string_test.voc_v"></b-form-input>
          </b-col>
          <b-col class="mb-2" sm="12" md="6" lg="4" xl="3">
            <label for="" class="text-white">VOC STC (V)</label>
            <b-form-input type="number" v-model="oModel.pvTest_update_string.pv_string_test.voc_stc"></b-form-input>
          </b-col>
          <b-col class="mb-2" sm="12" md="6" lg="4" xl="3">
            <label for="" class="text-white">Irradiance (W/m2)</label>
            <b-form-input type="number" v-model="oModel.pvTest_update_string.pv_string_test.irradiance"></b-form-input>
          </b-col>
          <b-col class="mb-2" sm="12" md="6" lg="4" xl="3">
            <label for="" class="text-white">% of VOC / VOC (STC)</label>
            <b-form-input type="number" v-model="oModel.pvTest_update_string.pv_string_test.voc_percentage"></b-form-input>
          </b-col>
          <b-col class="mb-2" sm="12" md="6" lg="4" xl="3">
            <label for="" class="text-white">Tilt (degree)</label>
            <b-form-input type="number" v-model="oModel.pvTest_update_string.pv_string_test.tilt"></b-form-input>
          </b-col>
          <b-col class="mb-2" sm="12" md="6" lg="4" xl="3">
            <label for="" class="text-white" title="(N=0, E=90, S=180, W=270)">Azimuth</label>
            <b-form-input type="number" v-model="oModel.pvTest_update_string.pv_string_test.azimuth"></b-form-input>
          </b-col>
          <b-col class="mb-2" sm="12" md="6" lg="4" xl="3">
            <label for="" class="text-white">Module Air Gap (mm)</label>
            <b-form-input type="number" v-model="oModel.pvTest_update_string.pv_string_test.module_air_gap"></b-form-input>
          </b-col>
          <b-col class="mb-2" sm="12" md="6" lg="4" xl="3">
            <label for="" class="text-white">Roof Type</label>
            <b-form-input v-model="oModel.pvTest_update_string.pv_string_test.roof_type"></b-form-input>
          </b-col>
        </b-row>

        <!-- buttons -->
        <b-row style="padding-top: 20px;" v-if="is_editable">
          <b-col class="text-right">
            <base-button @click="modal_close('modal-pv-test-update-string-entry')" type="danger" outline>Cancel</base-button>
            <base-button @click="batch_process_update_pv_test_string_entry()" type="primary">Save</base-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <!-- modal batch rename string entry -->
    <b-modal ref="modal-pv-test-rename-string-entry" size="lg" centered hide-footer hide-header title="">
      <div class="d-block">
        <b-row class="modal-row-header">
          <b-col>
            <div class="text-white h3"># Batch Rename String</div>
          </b-col>
        </b-row>
        <!-- string prefix and postfix -->
        <b-row>
          <b-col class="mb-2" sm="12" md="12" lg="6" xl="6">
            <label class="mb-1 text-white" for="">Prefix for String entry</label>
            <b-form-input placeholder="Prefix for String entry" v-model="oModel.pvTest_new_string.prefix"></b-form-input>
          </b-col>
          <b-col class="mb-2" sm="12" md="12" lg="6" xl="6">
            <label class="mb-1 text-white" for="">Optional: Postfix for String entry</label>
            <b-form-input placeholder="Optional: Postfix for String entry" v-model="oModel.pvTest_new_string.postfix"></b-form-input>
          </b-col>

        </b-row>
        <!-- information -->
        <b-row>
          <b-col class="mb-2" sm="12" md="12" lg="12" xl="12">
            <span style="color: white; font-family: Open Sans, sans-serif; font-size: 0.9rem; font-weight: 400;">
              Information: 
              <br>Batch rename is in sequential, so if an inverter has 12 string then the string will be rename start from 1 until 12.
            </span>
          </b-col>          
        </b-row>        
        <b-row style="padding-top: 20px;" v-if="is_editable">
          <b-col class="text-right">
            <base-button @click="modal_close('modal-pv-test-rename-string-entry')" type="danger" outline>Cancel</base-button>
            <base-button @click="batch_process_rename_pv_test_string_entry()" type="primary">Save</base-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { LoginURL, clientId, clientSecret, apiDomain, getHeader, getcurrentDate } from "@/assets/js/config.js";
import ErrorFunctionMixin from "@/assets/js/errorFunctionMix.js";
import CustomLibHelper from "@/assets/js/customLibHelper.js";
import axios from "axios";

import { AgGridVue } from "@ag-grid-community/vue";
import HeaderGroupComponent from './HeaderGroupComponent.vue';
import '@ag-grid-enterprise/core';
import { ToggleButton } from 'vue-js-toggle-button'

import { isEmpty, cloneDeep, pick } from "lodash";

import btnEditPVString from './gridBtn_edit_pv_string_.vue';

export default {
  props: ['shareData', 'pveData'],
  mixins: [ErrorFunctionMixin, CustomLibHelper],
  components: {
    'ag-grid-vue': AgGridVue,
    HeaderGroupComponent,
    ToggleButton,
    btnEditPVString,
  },
  data() {
    return {
      oDev: {
        debug: false,
      },
      oField: {
        toggle_color: {checked: '#75C791', unchecked: '#Cf3140', disabled: '#CCCCCC'},
        toggle_pass: {checked: 'Pass', unchecked: 'Not Pass'},  
      },
      oGrid: {
        api_pve: null,
        gridOptions_pv_inverter: null,
        columnDefs_pv_inverter: null,
        detailCellRendererParams_pv_string: null,
        selected: {
          inverter: null,
          string: null,
        }
      },
      defaultColDef: {
        flex: 1,
        minWidth: 100,
      },
      oModel: {
        pv_electrical_test: [],
        pvTest_new_inverter: {
          create: null,
          prefix: 'INV ',
          start: 1,
        },
        pvTest_update_inverter: {
          inverter_no: '',
          no_of_strings: '',
          dc_ac_ratio: '',
          dc_cable_type_and_size: '',
          capacity: '',
          model_no: '',
          inverter_serial_no: '',
          earth_cable_type_and_size: '',
          socpd_type: '',
          socpd_rating: '',
          socpd_dc_rating: '',
          socpd_capacity: '',
        },
        pvTest_new_string: {
          create: null,
          prefix: 'S',
          postfix: '',
          start: 1,
        },
        pvTest_update_string: {
          string_no: '',
          pv_modules_per_string: '',
          positive_earth: '',
          negative_earth: '',
          string_polarity_check: false,
          pv_string_test: {
            isc_a: '',
            isc_stc_a: '',
            voc_v: '',
            voc_stc: '',
            irradiance: '',
            voc_percentage: '',
            tilt: '',
            azimuth: '',
            module_air_gap: '',
            roof_type: '',
          }
        },
      },
      oDefault: {
        inverter_prefix: 'INV ',
        inverter_start: 1,
        string_prefix: 'S',
        string_postfix: '',
        string_start: 1,
      }
      //_ unused
    }
  },
  computed: {
    is_editable() {
      return this.shareData.is_epc && this.shareData.status_tnc != 'APPROVED'
    }
  },  
  methods: {
    onGridReady(params) {
      this.devMsg(this.oDev.debug, 'onGridReady - pv electrical test', 'gs')
      this.devMsg(this.oDev.debug, this.pveData);

      // this.oGrid.api_pve.value = params.api;
      this.oGrid.api_pve = params.api;
      this.oGrid.api_pve.sizeColumnsToFit();

      params.api.updateGridOptions({ rowData: this.pveData });

      this.devMsg(this.oDev.debug, this.oGrid.api_pve)
      this.devMsg(this.oDev.debug, '', 'ge')
    },
    grid_construct_gridOptions_pv_inverter() {
      this.oGrid.gridOptions_pv_inverter = {
        columnDefs: [
          { headerName: '', minWidth: 60, width: 60, headerCheckboxSelection: true, checkboxSelection: true, sortable: false,
            headerClass: '',
            pinned: true,
            cellClass: ''
          },
          { headerName: 'Inverter #', field: "inverter_no", cellRenderer: 'agGroupCellRenderer', 
            headerClass: 'ag-center-content', width: 350,
            // suppressHeaderMenuButton: true,
            // type: 'rightAligned',
            // editable: true,
          },
          { headerName: 'Inverter SN#', field: "inverter_serial_no",
            headerClass: 'ag-center-content', width: 200,
            cellRenderer: (params) => (params.value != '-to be update-') ? params.value.toString() : '',
          },
          { headerName: 'Model', field: "model_no",
            headerClass: 'ag-center-content', width: 350,
            cellRenderer: (params) => (params.value != '-to be update-') ? params.value.toString() : '',
          },
          { headerName: '# of Strings', field: "no_of_strings", 
            headerClass: 'ag-center-content', width: 150, type: 'rightAligned',
            cellRenderer: (params) => params.value ? params.value.toString() : '',
          },
          { headerName: 'Capacity', field: "capacity",
            headerClass: '', width: 100, type: 'rightAligned',
            cellRenderer: (params) => params.value ? params.value.toString() : '',
          },
          { headerName: 'DC/AC ratio', field: "dc_ac_ratio",
            headerClass: '', width: 100, type: 'rightAligned',
            cellRenderer: (params) => params.value ? params.value.toString() : '',
          },
          { headerName: 'DC cable type & size', field: "dc_cable_type_and_size",
            headerClass: '', width: 100,
            cellRenderer: (params) => (params.value != '-to be update-') ? params.value.toString() : '',
          },
          { headerName: 'Earth cable type & size', field: "earth_cable_type_and_size",
            headerClass: '', width: 100,
            cellRenderer: (params) => (params.value != '-to be update-') ? params.value.toString() : '',
          },
          {
            headerName: 'String over current over protection device',
            headerGroupComponent: 'HeaderGroupComponent',
            headerClass: 'ag-center-content',
            children: [
              { headerName: "Type", field: "socpd_type", headerClass: 'ag-center-content',
                cellRenderer: (params) => (params.value != '-to be update-') ? params.value.toString() : '',
              },
              { headerName: "Rating (A)", field: "socpd_rating", flex: 1.5, headerClass: 'ag-center-content', type: 'rightAligned', 
                cellRenderer: (params) => params.value ? params.value.toString() : '',
              }, 
              { headerName: "DC Rating (V)", field: "socpd_dc_rating", flex: 1.5, headerClass: 'ag-center-content', type: 'rightAligned', 
                cellRenderer: (params) => params.value ? params.value.toString() : '',
              }, 
              { headerName: "Capacity (KA)", field: "socpd_capacity", flex: 1.5, headerClass: 'ag-center-content', type: 'rightAligned', 
                cellRenderer: (params) => params.value ? params.value.toString() : '',
              }, 
            ]
          },
          ],
          headerHeight: 38,
          defaultColDef: {
            flex: 1,
          },
          // groupDefaultExpanded: 1,
          detailRowHeight: 300,
          detailRowAutoHeight: true,
          masterDetail: true,
          detailCellRendererParams: (params) => {
            var pvString = {};
            // pvString.refreshStrategy = 'everything';
            pvString.detailGridOptions = {
              rowSelection: 'multiple',
              columnDefs: [
                // {
                //   headerName: '#', minWidth: 60, width: 60, checkboxSelection: true, sortable: false,
                //   headerClass: '',
                //   pinned: true,
                //   cellClass: ''
                // },
                {
                  headerName: 'Actions', field: 'actions', headerClass: 'ag-pv-string', 
                  cellRenderer: 'btnEditPVString',
                  cellRendererParams : {
                    actionEdit : this.edit_selected_pv_string.bind(this) // this is your parent component function
                  }
                },                    
                { headerName: "String No", field: "string_no", flex: 1.5, headerClass: 'ag-pv-string' },
                { headerName: "PV module per-string", field: "pv_modules_per_string", 
                  flex: 1.5, headerClass: 'ag-pv-string ag-center-content', type: 'rightAligned', 
                  cellRenderer: (params) => params.value ? params.value.toString() : '',
                },
                { headerName: "Positive - Earth", field: "positive_earth", 
                  headerClass: 'ag-pv-string ag-center-content', type: 'rightAligned',
                  cellRenderer: (params) => (params.value != '-to be update-') ? params.value.toString() : '',
                },
                { headerName: "Negative - Earth", field: "negative_earth", 
                  headerClass: 'ag-pv-string ag-center-content', type: 'rightAligned', 
                  cellRenderer: (params) => (params.value != '-to be update-') ? params.value.toString() : '',  
                },       
                { headerName: "String Polarity Check", headerClass: 'ag-pv-string', field: "string_polarity_check", 
                  cellRenderer: (params) => (params.value == 0) ? 'Fail' : 'Pass',
                },    
                {
                  headerName: 'String Test',
                  headerGroupComponent: 'HeaderGroupComponent',
                  headerClass: 'ag-pv-string ag-center-content',
                  children: [
                    { headerName: "ISC (A)", field: "pv_string_test.isc_a", flex: 1.5, headerClass: 'ag-pv-string ag-center-content', type: 'rightAligned', 
                      cellRenderer: (params) => params.value ? params.value.toString() : '',
                    }, 
                    { headerName: "ISC @ STC (A)", field: "pv_string_test.isc_stc_a", flex: 1.5, headerClass: 'ag-pv-string ag-center-content', type: 'rightAligned', 
                      cellRenderer: (params) => params.value ? params.value.toString() : '',
                    }, 
                    { headerName: "VOC (V)", field: "pv_string_test.voc_v", flex: 1.5, headerClass: 'ag-pv-string ag-center-content', type: 'rightAligned', 
                      cellRenderer: (params) => params.value ? params.value.toString() : '',
                    }, 
                    { headerName: "VOC @ STC (V)", field: "pv_string_test.voc_stc", flex: 1.5, headerClass: 'ag-pv-string ag-center-content', type: 'rightAligned', 
                      cellRenderer: (params) => params.value ? params.value.toString() : '',
                    }, 
                    { headerName: "Irradiance (W/m2)", field: "pv_string_test.irradiance", flex: 1.5, headerClass: 'ag-pv-string ag-center-content', type: 'rightAligned', 
                      cellRenderer: (params) => params.value ? params.value.toString() : '',
                    }, 
                    { headerName: "% of VOC", field: "pv_string_test.voc_percentage", flex: 1.5, headerClass: 'ag-pv-string ag-center-content', type: 'rightAligned', 
                      cellRenderer: (params) => params.value ? params.value.toString() : '',
                    }, 
                    { headerName: "Tilt", field: "pv_string_test.tilt", flex: 1.5, headerClass: 'ag-pv-string ag-center-content', type: 'rightAligned', 
                      cellRenderer: (params) => params.value ? params.value.toString() : '',
                    }, 
                    { headerName: "Azimuth", field: "pv_string_test.azimuth", flex: 1.5, headerClass: 'ag-pv-string ag-center-content', type: 'rightAligned', 
                      cellRenderer: (params) => params.value ? params.value.toString() : '',
                    }, 
                    { headerName: "Module Air Gap (mm)", field: "pv_string_test.module_air_gap", flex: 1.5, headerClass: 'ag-pv-string ag-center-content', type: 'rightAligned', 
                      cellRenderer: (params) => params.value ? params.value.toString() : '',
                    }, 
                    {
                      headerName: "Roof Type",
                      headerClass: 'ag-pv-string ag-center-content',
                      field: "pv_string_test.roof_type",
                      cellRenderer: (params) => (params.value != '-to be update-') ? params.value.toString() : '',
                    },

                  ]
                },        
              ],
              context: {
                params: params,   // parent grid reference
              },
              headerHeight: 45,
              // onCellValueChanged: ($event) => {
              //   //_ this one is for sub grid milestone 
              //   this.populate_data_milestone_to_be_submit_into_db($event);
              // },
              defaultColDef: {
                flex: 1,
              },
              // groupDefaultExpanded: 1,
              detailRowHeight: 50,
              detailRowAutoHeight: true,
            };

            pvString.getDetailRowData = (params) => {
              params.successCallback(params.data.pv_electrical_sub_test);
            };

            return pvString;
          }        
      }
    },    

    // onSelectionChanged() {
    //   // const selectedData = this.oGrid.api_pve.value.getSelectedRows();
    //   const selectedData = this.oGrid.api_pve.getSelectedRows();
    //   console.log('Selection Changed', selectedData);
    // },

    //_ modal
    modal_show(whichModal, whatAction = "", isBatch = true) {
      //_ validation for certain modal before proceeding
      let bShowModal = true;
      
      //_ reset modal fields
      this.reset_new_generate_modal();

      let bCheckSelected = false;
      let errMsg = 'Please select Inverter.';
      let selectedData = null;
      selectedData = this.oGrid.api_pve.getSelectedRows();

      if (whatAction == 'update') {
        if ( isBatch ) {
          this.reset_pv_test_inverter_modal_fields();
          this.reset_pv_test_string_modal_fields();

          if (whichModal == 'modal-pv-test-update-inverter-entry') {
            errMsg = 'Please select Inverter entry to be update.'
          } else if (whichModal == 'modal-pv-test-update-string-entry') {
            errMsg = 'Please select Inverter for which String entry to be update.'
          } else {
            errMsg = 'Please select Inverter.';
          }

          bCheckSelected = true;
        }
      } else if ( whatAction == 'add_string' ) {
        errMsg = 'Please select Inverter that the string going to be add.'
        bCheckSelected = true;
      } else {
        //_ other action than above
      }
            
      if ( bCheckSelected ) {
        if (isEmpty(selectedData)) {
          this.redErrorNotify(errMsg);
          bShowModal = false;
        } 
      }

      (bShowModal) ? this.$refs[whichModal].show() : '';
    },
    modal_close(whichModal) {
      // this.devMsg(this.oDev.debug, 'modal_close', 'gs')
      // this.devMsg(this.oDev.debug, '', 'ge')

      this.$refs[whichModal].hide();
    },
    reset_new_generate_modal(){
      //_ use by both inverter and string, cause the string using the same model,
      //  and it's ok to reset it all to null
      this.oModel.pvTest_new_inverter.create = null;
      this.oModel.pvTest_new_inverter.prefix = this.oDefault.inverter_prefix;
      this.oModel.pvTest_new_inverter.start = this.oDefault.inverter_start;
      this.oModel.pvTest_new_string.create = null;
      this.oModel.pvTest_new_string.prefix = this.oDefault.string_prefix;
      this.oModel.pvTest_new_string.postfix = this.oDefault.string_postfix;
      this.oModel.pvTest_new_string.start = this.oDefault.string_start;
    },
    reset_pv_test_inverter_modal_fields() {
      this.oModel.pvTest_update_inverter = {
        inverter_no: '',
        no_of_strings: '',
        dc_ac_ratio: '',
        dc_cable_type_and_size: '',
        capacity: '',
        model_no: '',
        inverter_serial_no: '',
        earth_cable_type_and_size: '',
        socpd_type: '',
        socpd_rating: '',
        socpd_dc_rating: '',
        socpd_capacity: '',
      };
    },
    reset_pv_test_string_modal_fields() {
      this.oModel.pvTest_update_string = {
        string_no: '',
        pv_modules_per_string: '',
        positive_earth: '',
        negative_earth: '',
        string_polarity_check: false,
        pv_string_test: {
          isc_a: '',
          isc_stc_a: '',
          voc_v: '',
          voc_stc: '',
          irradiance: '',
          voc_percentage: '',
          tilt: '',
          azimuth: '',
          module_air_gap: '',
          roof_type: '',
        }
      };
    },
    
    //_ INVERTER
    //_ add new entry for both inverter and string
    batch_process_add_pv_test_inverter_entry() {
      /**
       * similar with ac_test but since pv electrical test can be multiple then we prepare array of data
       * the structure will be multiple INVERTER (field pv_electrical_test)
       * and on each of INVERTER can hold multiple STRING (field pv_electrical_sub_test)
       * 
       * we make the form bit dynamic by allowing the user the enter prefix for inverter and string name, and also start from what number
       * 
       * we only check how many inverter or string wants to be create, 
       * the other fields, such as prefix and start from, we set it using default value, but if the user set it empty, it will use the default value
       */
      this.devMsg(this.oDev.debug, 'batch_process_add_pv_test_inverter_entry', 'gs')

      let bProceed = false
      if ( this.oModel.pvTest_new_inverter.create === null || this.oModel.pvTest_new_inverter.create < 1 || this.oModel.pvTest_new_string.create === null || this.oModel.pvTest_new_string.create < 1) {
        this.redErrorNotify("<b>All fields are required to be input.</b>");
      } else {
        bProceed = true;
      }

      if ( bProceed ) {
        this.$refs['modal-loading-in-progress'].show();

        this.devMsg(this.oDev.debug, 'param id: ' + this.$route.params.id)

        this.devMsg(this.oDev.debug, 'this.pveData')
        this.devMsg(this.oDev.debug, this.pveData)

        this.oModel.pv_electrical_test = []

        let inverter_prefix = (this.oModel.pvTest_new_inverter.prefix == '') ? this.oDefault.inverter_prefix : this.oModel.pvTest_new_inverter.prefix;
        let inverter_start = (this.oModel.pvTest_new_inverter.start == '') ? this.oDefault.inverter_start : Number(this.oModel.pvTest_new_inverter.start);
        let string_prefix = (this.oModel.pvTest_new_string.prefix == '') ? this.oDefault.string_prefix : this.oModel.pvTest_new_string.prefix;
        let string_postfix = (this.oModel.pvTest_new_string.postfix == '') ? this.oDefault.string_postfix : this.oModel.pvTest_new_string.postfix;
        for (let countInverter = 0; countInverter < this.oModel.pvTest_new_inverter.create; countInverter++) {
          // this.devMsg(this.oDev.debug, 'INV ' + (countInverter+1));

          // let template_pve_test = this.template_pve_test('INV ' + (countInverter+1), this.oModel.pvTest_new_string.create);
          let inverter_no = inverter_prefix + (inverter_start + countInverter);
          let template_pve_test = this.template_pve_test(inverter_no, this.oModel.pvTest_new_string.create);
          this.oModel.pv_electrical_test.push(template_pve_test);

          let tmp_pveSubData = []
          for (let countString = 0; countString < this.oModel.pvTest_new_string.create; countString++) {
            this.devMsg(this.oDev.debug, 'countInverter: ' + countInverter + ' => countString: ' + countString)

            // let template_pve_sub_test = this.template_pve_sub_test('S' + (countString+1));
            let template_pve_sub_test = this.template_pve_sub_test(string_prefix + (countString+1) + string_postfix);
            tmp_pveSubData.push(template_pve_sub_test)
          }
          
          this.oModel.pv_electrical_test[countInverter].pv_electrical_sub_test = tmp_pveSubData
        }

        this.devMsg(this.oDev.debug, 'to be submit to db')
        this.devMsg (this.oModel.pv_electrical_test)

        let formData = [];
        formData = {pv_electrical_test:  this.oModel.pv_electrical_test };

        let api_url = apiDomain + 'qaqc/create_qaqc_pv_electrical_test/' + this.$route.params.id;
        axios
        //temp comment original code
        //.post(api_url, this.oModel.pv_electrical_test, { headers: getHeader() })
        .post(api_url, formData, { headers: getHeader() })
        .then((response) => {
          if (response.status === 200) {
            this.msg_notify_ok('<b>PV Electrical Test Entry Successfully Created.</b>');
          }
        })
        .catch((error) => {
          if (error.response) {
            // Handle error with response
            this.errorFunction(error, "Batch create PV Electrical Test Entry");
          } else {
            // Handle error without response
            this.msg_notify_sembcorp();
          }
        })
        .finally(() => {
          this.$refs['modal-loading-in-progress'].hide();
          this.modal_close('modal-pv-test-generate-inverter-entry')

          this.$router.go(0);
        });

      }

      this.devMsg(this.oDev.debug, '', 'ge')
    },
    //_ only update the inverter entry
    batch_process_update_pv_test_inverter_entry() {
      /**
       * user selected data (selectedData) going to be update, based on the modal dialog field that has value
       * so empty field from the modal will not be update into the selected data (selectedData)
       * NOTE: this only update the INVERTER, not the STRING
       */

      this.devMsg(this.oDev.debug, 'batch_process_update_pv_test_inverter_entry', 'gs')

      let selectedData = this.oGrid.api_pve.getSelectedRows();
      let bProceed = false;

      if (isEmpty(selectedData)) {
        this.redErrorNotify('Please select Inverter entry to be update.');
      } else {
        bProceed = true;
      }

      let new_keys;
      let new_obj = {};
      if (bProceed) {
        this.$refs['modal-loading-in-progress'].show();

        this.devMsg(this.oDev.debug, 'this.oModel.pvTest_update_inverter')
        this.devMsg(this.oDev.debug, this.oModel.pvTest_update_inverter)
        
        //_ get the ui fields and then remove that is not populated
        let old_obj = this.oModel.pvTest_update_inverter
        let removeValue = ''
        new_keys = Object.keys(old_obj).filter(this_entry => old_obj[this_entry] !== removeValue);
        new_keys.forEach(key => new_obj[key] = old_obj[key]);

        this.devMsg(this.oDev.debug, 'old_obj');
        this.devMsg(this.oDev.debug, old_obj);
        this.devMsg(this.oDev.debug, 'new_obj');
        this.devMsg(this.oDev.debug, new_obj);

        //_ applying the filled up UI field into the selectedData
        selectedData.forEach( (entry => {
          this.devMsg(this.oDev.debug, '>>> populating data', 'gs')
          // if ( new_obj.hasOwnProperty('cable_type_and_size') ) console.log(new_obj.cable_type_and_size);
          if ( new_obj.inverter_no !== undefined ) entry.inverter_no = new_obj.inverter_no;
          if ( new_obj.no_of_strings !== undefined ) entry.no_of_strings = new_obj.no_of_strings;
          if ( new_obj.dc_ac_ratio !== undefined ) entry.dc_ac_ratio = new_obj.dc_ac_ratio;
          if ( new_obj.dc_cable_type_and_size !== undefined ) entry.dc_cable_type_and_size = new_obj.dc_cable_type_and_size;
          if ( new_obj.capacity !== undefined ) entry.capacity = new_obj.capacity;
          if ( new_obj.model_no !== undefined ) entry.model_no = new_obj.model_no;
          if ( new_obj.inverter_serial_no !== undefined ) entry.inverter_serial_no = new_obj.inverter_serial_no;
          if ( new_obj.earth_cable_type_and_size !== undefined ) entry.earth_cable_type_and_size = new_obj.earth_cable_type_and_size;
          if ( new_obj.socpd_type !== undefined ) entry.socpd_type = new_obj.socpd_type;
          if ( new_obj.socpd_rating !== undefined ) entry.socpd_rating = new_obj.socpd_rating;
          if ( new_obj.socpd_dc_rating !== undefined ) entry.socpd_dc_rating = new_obj.socpd_dc_rating;
          if ( new_obj.socpd_capacity !== undefined ) entry.socpd_capacity = new_obj.socpd_capacity;

          this.devMsg(this.oDev.debug, '', 'ge')
        }))
        
        this.devMsg(this.oDev.debug, 'selectedData')
        this.devMsg(this.oDev.debug, selectedData);     

        let api_url = apiDomain + 'qaqc/update_qaqc_pv_electrical_test/' + this.$route.params.id;
        let formData = [];
        formData = {pv_electrical_test: selectedData };

        this.devMsg(this.oDev.debug, 'formData')
        this.devMsg(this.oDev.debug, formData)

        axios
        .post(api_url, formData, { headers: getHeader() })
        .then((response) => {
          if (response.status === 200) {
            this.msg_notify_ok('<b>PV Electrical Test Entry Successfully Updated.</b>');
          }
        })
        .catch((error) => {
          if (error.response) {
            // Handle error with response
            this.errorFunction(error, "Batch Update PV Electrical Test");
          } else {
            // Handle error without response
            this.msg_notify_sembcorp();
          }
        })
        .finally(() => {
          this.oGrid.api_pve.refreshCells()
          this.$refs['modal-loading-in-progress'].hide();
          this.modal_close('modal-pv-test-update-inverter-entry')          
        });         
      }

      this.devMsg(this.oDev.debug, '', 'ge')
    },

    //_ STRING
    batch_process_add_pv_test_string_entry() {
      let bProceed = false
      let dbModel = []

      if ( this.oModel.pvTest_new_string.create === null || this.oModel.pvTest_new_string.create < 1) {
        this.redErrorNotify("<b>Field is required to be input.</b>");
      } else {
        let selectedData = this.oGrid.api_pve.getSelectedRows();
        if (isEmpty(selectedData)) {
          this.redErrorNotify('Please select Inverter.');
        } else {
          this.devMsg(this.oDev.debug, 'selectedData');
          this.devMsg(this.oDev.debug, selectedData);

          let string_start = (this.oModel.pvTest_new_string.start == '') ? this.oDefault.string_start : Number(this.oModel.pvTest_new_string.start);
          let string_prefix = (this.oModel.pvTest_new_string.prefix == '') ? this.oDefault.string_prefix : this.oModel.pvTest_new_string.prefix;
          let string_postfix = (this.oModel.pvTest_new_string.postfix == '') ? this.oDefault.string_postfix : this.oModel.pvTest_new_string.postfix;

          dbModel = cloneDeep(selectedData);

          dbModel.forEach( (entryInverter => {
            entryInverter.pv_electrical_sub_test = []
            let tmp_pveSubData = []
            for (let countString = 0; countString < this.oModel.pvTest_new_string.create; countString++) {
              let template_pve_sub_test = this.template_pve_sub_test(string_prefix + (string_start + countString) + string_postfix);
              tmp_pveSubData.push(template_pve_sub_test)
            }
            
            entryInverter.pv_electrical_sub_test = tmp_pveSubData
          }))

          this.devMsg(this.oDev.debug, 'dbModel');
          this.devMsg(this.oDev.debug, dbModel);

          bProceed = true;
        }
      }

      if ( bProceed ) {
        this.$refs['modal-loading-in-progress'].show();

        let api_url = apiDomain + 'qaqc/update_qaqc_pv_electrical_test/' + this.$route.params.id;
        let formData = [];
        formData = {pv_electrical_test: dbModel };

        this.devMsg(this.oDev.debug, 'formData')
        this.devMsg(this.oDev.debug, formData)

        axios
        .post(api_url, formData, { headers: getHeader() })
        .then((response) => {
          if (response.status === 200) {
            this.msg_notify_ok('<b>PV Successfully added new String entry on selected Inverter.</b>');
          }
        })
        .catch((error) => {
          if (error.response) {
            // Handle error with response
            this.errorFunction(error, "Batch Add new string entry");
          } else {
            // Handle error without response
            this.msg_notify_sembcorp();
          }
        })
        .finally(() => {
          this.modal_close('modal-pv-test-generate-string-entry')
          this.$refs['modal-loading-in-progress'].hide();

          //_ reload the whole page, so far no other way to refresh the UI with new entry
          this.$router.go(0);
        });
      }
    },    
    batch_process_update_pv_test_string_entry() {
      this.devMsg(this.oDev.debug, 'batch_process_update_pv_test_string_entry', 'gs')

      let bProceed = false;
      this.oModel.pv_electrical_test = []
      let dbModel = []

      /** brief explanation of the code :)
       * WHY using 3 fields that hold "similar" object -> this.oModel.pv_electrical_test | this.oGrid.selected.string | dbModel
       *    because we need to maintain modal AND grid AND what to be save into the db, and there is slightly different format of value 
       *    for example the toggle button accepting true and false, BUT the db/api accepting 1 and 0
       *    nothing we can do with the toggle button, cannot change the default value through parameter, except we look for other library
       * 
       *  so if we use only 1 model, it'll mess up the UI
       *  we can use 1 model, but everytime an update happens then the whole page need to be reload
       * 
       *  -> this.oModel.pv_electrical_test is use by the modal dialog,
       *  -> this.oGrid.selected.string is use by the grid,
       *  -> dbModel, this one we use to update the db,
       * 
       * note: WHY using clonedeep, why not just modelA = modelB ?
       *    because by using clonedeep, the new object is not reference using the same memory 
       *    if we using modelA = modelB, any changes in modelB will be reflected back to modelA, because it's using the same memory
       */      

      //_ SINGLE or BATCH entry update
      if ( this.oGrid.selected.inverter != null ) {
        // single entry update
        this.devMsg(this.oDev.debug, 'single entry update')

        //_ reset pv_electrical_sub_test to nothing, and then just need to push the data from STRING modal that has been updated by the user
        this.oModel.pv_electrical_test = cloneDeep(this.oGrid.selected.inverter);
        this.oModel.pv_electrical_test.pv_electrical_sub_test = [];
        this.oModel.pv_electrical_test.pv_electrical_sub_test.push(this.oModel.pvTest_update_string);

        //_ also update the UI grid display, without refreshing the whole page
        this.oGrid.selected.string = this.oModel.pvTest_update_string;

        dbModel.push(cloneDeep(this.oModel.pv_electrical_test));
        dbModel[0].pv_electrical_sub_test[0].string_polarity_check = this.convertToggle(dbModel[0].pv_electrical_sub_test[0].string_polarity_check, true);

        this.devMsg(this.oDev.debug, 'this.oModel.pv_electrical_test')
        this.devMsg(this.oDev.debug, this.oModel.pv_electrical_test)
        this.devMsg(this.oDev.debug, 'dbModel')
        this.devMsg(this.oDev.debug, dbModel)

        bProceed = true;
      } else {
        // batch entry update
        this.devMsg(this.oDev.debug, 'batch entry update')
        let selectedData = this.oGrid.api_pve.getSelectedRows();

        if (isEmpty(selectedData)) {
          this.redErrorNotify('Please select String entry to be update.');
        } else {
          this.devMsg(this.oDev.debug, selectedData);
          // alert(`Selected Data:\n${JSON.stringify(selectedData)}`);

          //_ get the ui fields and then remove that is not populated
          let new_keys;
          let new_obj = {};

          let old_obj = this.oModel.pvTest_update_string
          let removeValue = ''
          new_keys = Object.keys(old_obj).filter(this_entry => old_obj[this_entry] !== removeValue);
          new_keys.forEach(key => new_obj[key] = old_obj[key]);

          this.devMsg(this.oDev.debug, 'old_obj');
          this.devMsg(this.oDev.debug, old_obj);
          this.devMsg(this.oDev.debug, 'new_obj');
          this.devMsg(this.oDev.debug, new_obj);     

          //_ applying the filled up UI field into the selectedData
          selectedData.forEach( (entryInverter => {
            this.devMsg(this.oDev.debug, '>>> populating data', 'gs')

            entryInverter.pv_electrical_sub_test.forEach( (entry => {
              // if ( new_obj.hasOwnProperty('cable_type_and_size') ) console.log(new_obj.cable_type_and_size);
              if ( new_obj.string_no !== undefined ) entry.string_no = new_obj.string_no;
              if ( new_obj.pv_modules_per_string !== undefined ) entry.pv_modules_per_string = new_obj.pv_modules_per_string;
              if ( new_obj.positive_earth !== undefined ) entry.positive_earth = new_obj.positive_earth;
              if ( new_obj.negative_earth !== undefined ) entry.negative_earth = new_obj.negative_earth;
              if ( new_obj.string_polarity_check !== undefined ) entry.string_polarity_check = new_obj.string_polarity_check;
              if ( new_obj.pv_string_test.isc_a !== '' ) entry.pv_string_test.isc_a = new_obj.pv_string_test.isc_a;
              if ( new_obj.pv_string_test.isc_stc_a !== '' ) entry.pv_string_test.isc_stc_a = new_obj.pv_string_test.isc_stc_a;
              if ( new_obj.pv_string_test.voc_v !== '' ) entry.pv_string_test.voc_v = new_obj.pv_string_test.voc_v;
              if ( new_obj.pv_string_test.voc_stc !== '' ) entry.pv_string_test.voc_stc = new_obj.pv_string_test.voc_stc;
              if ( new_obj.pv_string_test.irradiance !== '' ) entry.pv_string_test.irradiance = new_obj.pv_string_test.irradiance;
              if ( new_obj.pv_string_test.voc_percentage !== '' ) entry.pv_string_test.voc_percentage = new_obj.pv_string_test.voc_percentage;
              if ( new_obj.pv_string_test.tilt !== '' ) entry.pv_string_test.tilt = new_obj.pv_string_test.tilt;
              if ( new_obj.pv_string_test.azimuth !== '' ) entry.pv_string_test.azimuth = new_obj.pv_string_test.azimuth;
              if ( new_obj.pv_string_test.module_air_gap !== '' ) entry.pv_string_test.module_air_gap = new_obj.pv_string_test.module_air_gap;
              if ( new_obj.pv_string_test.roof_type !== '' ) entry.pv_string_test.roof_type = new_obj.pv_string_test.roof_type;
            }))

            this.devMsg(this.oDev.debug, '', 'ge')
          }))
 
          this.devMsg(this.oDev.debug, 'selectedData')
          this.devMsg(this.oDev.debug, selectedData); 

          dbModel = cloneDeep(selectedData);
          dbModel.forEach( (entryInverter => {
            entryInverter.pv_electrical_sub_test.forEach( (entry => {
              entry.string_polarity_check = this.convertToggle(entry.string_polarity_check, true);
            }))
          }))
 
          this.devMsg(this.oDev.debug, 'dbModel')
          this.devMsg(this.oDev.debug, dbModel); 
                    
          bProceed = true;
        }        
      }

      if ( bProceed ) {
        this.$refs['modal-loading-in-progress'].show();

        let api_url = apiDomain + 'qaqc/update_qaqc_pv_electrical_test/' + this.$route.params.id;
        let formData = [];
        formData = {pv_electrical_test: dbModel };

        this.devMsg(this.oDev.debug, 'formData')
        this.devMsg(this.oDev.debug, formData)

        axios
        .post(api_url, formData, { headers: getHeader() })
        .then((response) => {
          if (response.status === 200) {
            this.msg_notify_ok('<b>PV Electrical Test Entry Successfully Updated.</b>');
          }
        })
        .catch((error) => {
          if (error.response) {
            // Handle error with response
            this.errorFunction(error, "Batch Update PV Electrical Test");
          } else {
            // Handle error without response
            this.msg_notify_sembcorp();
          }
        })
        .finally(() => {
          // this.oGrid.api_pve.refreshCells()      //_ this way cannot refresh the master detail data in the grid

          //_ currently this is the only way, loop through all node (sub grid), and then if it expand, then collapse it after that expand it again
          //  because this is the only way to refresh the data on the UI without reloading the page.
          this.oGrid.api_pve.forEachNode(function (node) {
            if ( node.expanded ) {
              node.expanded = false;
              node.expanded = true;
            }
          });
          this.oGrid.api_pve.onGroupExpandedOrCollapsed();

          this.modal_close('modal-pv-test-update-string-entry')
          this.$refs['modal-loading-in-progress'].hide();
        });       
      }
            
      this.devMsg(this.oDev.debug, 'reset selected grid data')
      //_ after update to db, need to reset selected grid data, cause we using this as validation to check if it single or batch entry update
      //  single: because we populate this.oGrid.selected with data when we click "EDIT" on the STRING entry
      //  batch: because it should be empty, cause default nothing fill it, and when update string complete it also set as original state again 
      this.oGrid.selected = {
        inverter: null,
        string: null,
      };

      this.devMsg(this.oDev.debug, '', 'ge')
      // return selectedData;
    },
    edit_selected_pv_string(dataInverter=null, dataString=null) {
      /**
       * get value from selected data when the user click "EDIT" on selected STRING
       * STRING value got from sub grid selected row
       * INVERTER value from parent grid of selected row
       * how?: take a look at detailCellRendererParams inside method grid_construct_gridOptions_pv_inverter()
       *    it renders a button, when clicked it'll send the value from grid object to parent method edit_selected_pv_string (this one that you read right now) 
       * 
       * then we just need to populate the STRING modal with the data we got from the grid
       * then show it to the user
       * 
       * faster and better this way, no api calls anymore to get the data, since the data that needed stored in the grid object
       */
      this.devMsg(this.oDev.debug, 'edit_selected_pv_string', 'gs')

      
      this.oGrid.selected = {
        inverter: dataInverter,
        string: dataString,
      };
      this.devMsg(this.oDev.debug, 'this.oGrid.selected')
      this.devMsg(this.oDev.debug, this.oGrid.selected)

      //_ populate selected string modal fields
      // this.oModel.pvTest_update_string.string_no = dataString.string_no;
      // this.oModel.pvTest_update_string.pv_modules_per_string = dataString.pv_modules_per_string;
      // this.oModel.pvTest_update_string.positive_earth = dataString.positive_earth;
      // this.oModel.pvTest_update_string.negative_earth = dataString.negative_earth;
      // this.oModel.pvTest_update_string.string_polarity_check = this.convertToggle(dataString.string_polarity_check);
      // this.oModel.pvTest_update_string.pv_string_test.isc_a = dataString.pv_string_test.isc_a;
      // this.oModel.pvTest_update_string.pv_string_test.isc_stc_a = dataString.pv_string_test.isc_stc_a;
      // this.oModel.pvTest_update_string.pv_string_test.voc_v = dataString.pv_string_test.voc_v;
      // this.oModel.pvTest_update_string.pv_string_test.voc_stc = dataString.pv_string_test.voc_stc;
      // this.oModel.pvTest_update_string.pv_string_test.irradiance = dataString.pv_string_test.irradiance;
      // this.oModel.pvTest_update_string.pv_string_test.voc_percentage = dataString.pv_string_test.voc_percentage;
      // this.oModel.pvTest_update_string.pv_string_test.tilt = dataString.pv_string_test.tilt;
      // this.oModel.pvTest_update_string.pv_string_test.azimuth = dataString.pv_string_test.azimuth;
      // this.oModel.pvTest_update_string.pv_string_test.module_air_gap = dataString.pv_string_test.module_air_gap;
      // this.oModel.pvTest_update_string.pv_string_test.roof_type = dataString.pv_string_test.roof_type;

      this.oModel.pvTest_update_string = dataString
      this.oModel.pvTest_update_string.string_polarity_check = this.convertToggle(dataString.string_polarity_check);

      this.devMsg(this.oDev.debug, 'this.oModel.pvTest_update_string')
      this.devMsg(this.oDev.debug, this.oModel.pvTest_update_string)      

      this.modal_show('modal-pv-test-update-string-entry', 'update', false);
      this.devMsg(this.oDev.debug, '', 'ge')
    },
    batch_process_rename_pv_test_string_entry() {
      this.devMsg(this.oDev.debug, 'batch_process_rename_pv_test_string_entry', 'gs')

      let bProceed = false;
      this.oModel.pv_electrical_test = []
      let dbModel = []     
      
      let selectedData = this.oGrid.api_pve.getSelectedRows();
      if (isEmpty(selectedData)) {
        this.redErrorNotify('Please select Inverter.');
      } else {
        this.devMsg(this.oDev.debug, 'selectedData');
        this.devMsg(this.oDev.debug, selectedData);

        let string_prefix = (this.oModel.pvTest_new_string.prefix == '') ? this.oDefault.string_prefix : this.oModel.pvTest_new_string.prefix;
        let string_postfix = (this.oModel.pvTest_new_string.postfix == '') ? this.oDefault.string_postfix : this.oModel.pvTest_new_string.postfix;

        // dbModel = cloneDeep(selectedData);
        dbModel = selectedData;

        dbModel.forEach( (entryInverter => {
          let iCountString = 0;
          entryInverter.pv_electrical_sub_test.forEach( (entry => {
            iCountString++;
            entry.string_no = string_prefix + (iCountString) + string_postfix
          }))
        }))

        this.devMsg(this.oDev.debug, 'dbModel');
        this.devMsg(this.oDev.debug, dbModel);
        
        bProceed = true;
      }
            
      if ( bProceed ) {
        this.$refs['modal-loading-in-progress'].show();

        let api_url = apiDomain + 'qaqc/update_qaqc_pv_electrical_test/' + this.$route.params.id;
        let formData = [];
        formData = {pv_electrical_test: dbModel };

        this.devMsg(this.oDev.debug, 'formData')
        this.devMsg(this.oDev.debug, formData)

        axios
        .post(api_url, formData, { headers: getHeader() })
        .then((response) => {
          if (response.status === 200) {
            this.msg_notify_ok('<b>String Successfully Renamed.</b>');
          }
        })
        .catch((error) => {
          if (error.response) {
            // Handle error with response
            this.errorFunction(error, "Batch Rename String");
          } else {
            // Handle error without response
            this.msg_notify_sembcorp();
          }
        })
        .finally(() => {
          // this.oGrid.api_pve.refreshCells()      //_ this way cannot refresh the master detail data in the grid

          //_ currently this is the only way, loop through all node (sub grid), and then if it expand, then collapse it after that expand it again
          //  because this is the only way to refresh the data on the UI without reloading the page.
          this.oGrid.api_pve.forEachNode(function (node) {
            if ( node.expanded ) {
              node.expanded = false;
              node.expanded = true;
            }
          });
          this.oGrid.api_pve.onGroupExpandedOrCollapsed();

          this.modal_close('modal-pv-test-rename-string-entry')
          this.$refs['modal-loading-in-progress'].hide();
        });           
      }

      this.devMsg(this.oDev.debug, '', 'ge')
    },


    //_ libs helper specific this module only
    template_pve_test( inv_no = '', string_amount=0) {
      return {
        inverter_no: inv_no,
        no_of_strings: string_amount,
        dc_ac_ratio: 0,
        dc_cable_type_and_size: '-to be update-',
        capacity: 0,
        model_no: '-to be update-',
        inverter_serial_no: '-to be update-',
        earth_cable_type_and_size: '-to be update-',
        socpd_type: '-to be update-',
        socpd_rating: 0,
        socpd_dc_rating: 0,
        socpd_capacity: 0,
        pv_electrical_sub_test: []
      };
    },
    template_pve_sub_test( string_no = '' ) {
      return {
        string_no: string_no,
        pv_modules_per_string: 0,
        positive_earth: '-to be update-',
        negative_earth: '-to be update-',
        string_polarity_check: 0,
        pv_string_test: {
          isc_a: 0,
          isc_stc_a: 0,
          voc_v: 0,
          voc_stc: 0,
          tilt: 0,
          voc_percentage: 0,
          module_air_gap: 0,
          azimuth: 0,
          roof_type: '-to be update-',
        },
      }
    }
  },
  created() {
  },
  mounted() {
    
  },
  beforeMount() {
    this.grid_construct_gridOptions_pv_inverter();
  }
}
</script>


<!-- ag-grid related -->
<style>
.ag-pv-string {
  background-color: #bbbdbf;
}

.ag-center-content {
  justify-content: center;
}

.ag-header-cell-label .ag-header-cell-text {
  white-space: pre-wrap !important;
}

.column-2 {
  background-color: #c9daf8;
  /* light blue */
}

.column-3 {
  background-color: #d9ead3;
  /* light green */
}

.ag-root-wrapper-body.ag-layout-normal {
  height: 700px
}

.ag-cell {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}

label {
  font-weight: normal !important;
}

.bg-default-dashboard {
  background-color: #082A2F;
  padding: 0;
  margin: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.div-percent-bar {
  display: inline-block;
  height: 100%;
  position: relative;
  z-index: 0;
}

.div-percent-value {
  position: absolute;
  padding-left: 4px;
  font-weight: bold;
  font-size: 13px;
  z-index: 100;
}

.div-outer-div {
  display: inline-block;
  height: 100%;
  width: 100%;
}

.ag-menu {
  z-index: 200;
}

.toolbar button {
  margin-left: 5px;
  margin-right: 5px;
  padding: 2px;
}
</style>

<!-- form element -->
<style scoped>
/deep/ hr{
  background-color: white;
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

/deep/ .form-control {
  background-color: #2C545A;
  border-color: #2C545A;
  color: white;

  &:focus {
    background-color: #2C545A;
    border-color: #2C545A;
    /* color: white; */
  }

  &::placeholder {
    color: rgb(163, 163, 163);
  }
}

/deep/ .form-control {
  &:focus {
    &::placeholder {
      color: rgb(163, 163, 163);
    }
  }
}

/deep/ .input-group-text {
  background-color: #2C545A;
  ;
  color: white;

  &:focus {
    background-color: #2C545A;
    ;
    border-color: #1D4147;
    color: white;
  }
}

/deep/ input::-webkit-input-placeholder {
  color: #fff;
}

/deep/ input::-moz-input-placeholder {
  color: #fff;
}

/deep/ input::-ms-input-placeholder {
  color: #fff;
}

/deep/ .el-input .el-input__inner {
  background-color: #2C545A;
  color: #fff;
  border: 0px;
  border-radius: 10px;
  padding-top: 3px;
  padding-bottom: 2px;

  /* &::placeholder {
    color: white;
  } */
}

/deep/ .el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: #23504e;
}

/deep/ .el-select-dropdown {
  background-color: #306b74;
  margin: 0px;
}

/deep/ .el-select-dropdown__item {
  color: white;
  background-color: #183034;

  ::hover {
    background-color: #2C545A
  }

}

/deep/ .el-select {
  .el-input .el-input__inner {
    &::placeholder {
      color: white;
    }
  }

}

/deep/ .el-select__input {
  color: white;
  background-color: #2C545A;
}

/deep/ .el-select__input.hover,
.el-select__input:hover {
  background-color: #23504e;
}
</style>

<!-- modal -->
<style scoped>
/deep/ .modal-content {
  background-color: #306b74 !important;
}

/deep/ .modal-body {
  background-color: #306b74 !important;
}

/deep/ .modal-row-header {
  padding-bottom: 20px;
}

/deep/ .modal-row-category {
  padding-top: 5px;
  padding-bottom: 0px;
}
</style>

<!-- dropdown action menu -->
<style scoped>
/deep/ .btn-dark,
.btn-dark:hover {
  color: #fff;
  background-color: #2c545a;
  border-color: #2c545a;
}

/deep/ .dropdown-menu {
  background-color: #23444a !important;
  border: 1px solid #ffffff;
}

/deep/ .dropdown-item {
  &:hover {
    background-color: #3a656b !important;
    color: #ffffff;
  }

  span {
    padding-left: 8px;
    vertical-align: super;
  }
}
</style>